<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  [attr.viewBox]="def().viewBox"
  [attr.width]="px()"
  [attr.height]="px()"
  [innerHTML]="body()"
></svg>
